
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'
import { IconChargingWire } from '@ds/icons/IconChargingWire'
import { IconComputerMouse } from '@ds/icons/IconComputerMouse'
import { IconController } from '@ds/icons/IconController'
import { IconHdmi } from '@ds/icons/IconHdmi'
import { IconHeart } from '@ds/icons/IconHeart'
import { IconKeyboard } from '@ds/icons/IconKeyboard'
import { IconPlug } from '@ds/icons/IconPlug'
import { IconPowerAdapterApple } from '@ds/icons/IconPowerAdapterApple'

import { MODAL_NAMES } from '@config/constants'

import translations from './Accessories.translations'
import Chip from './components/Chip'
import ExcludedAccessoriesModal from './components/ExcludedAccessoriesModal'

const ICONS = {
  IconChargingWire,
  IconComputerMouse,
  IconController,
  IconHdmi,
  IconHeart,
  IconKeyboard,
  IconPlug,
  IconPowerAdapterApple,
}

export default {
  components: {
    RevLink,
    Chip,
    ExcludedAccessoriesModal,
  },
  props: {
    accessories: {
      type: Array,
      required: true,
    },
    showExcludedModal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    translations: () => translations,

    shouldDisplayAccessories() {
      return !!this.accessories.length
    },

    items() {
      return this.accessories.map((accessory) => ({
        icon: ICONS[accessory.icon],
        label: accessory.text,
      }))
    },
  },
  methods: {
    handleModalOpen() {
      openModal(MODAL_NAMES.PRODUCT.EXCLUDED_ACCESSORIES)
    },
  },
}
